import { API_URL } from "@/shared/config";

import { ISendMessageParams } from "../types";

class MessageSendingService {
  async sendMessage(params: ISendMessageParams, abortSignal: AbortSignal) {
    const { ai_chat_id, msg, type, prompt_id, correlation_id, dialog_id } =
      params;
    const response = await fetch(`${API_URL}/SendMessage`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        ai_chat_id,
        correlation_id,
        msg,
        type,
        dialog_id,
        prompt_id,
      }),
      signal: abortSignal,
    });

    if (!response.ok) {
      throw new Error(response.statusText || String(response.status));
    }

    if (!response.body) {
      throw new Error("Empty body");
    }

    return response.body.getReader();
  }
}

export const messageSendingService = new MessageSendingService();
